<template>
  <div class="tab" @click="click">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  background-color: $baseColor;
  width: 175px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 30px;
  z-index: 0;
  cursor: pointer;
  &.white {
    background-color: #fff;
    color: $baseColor;

  }
  img {
    width: 26px;
    margin-right: 5px;
  }
  span {
    text-align: center;
    font-size: 14px;
    line-height: 14px;
  }
}
</style>
